<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import fileTypeEnum from '../enums/fileType'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                packerContainerForm: () => import('../forms/PackerContainerForm'),
                fields: [
                    { type: 'autocomplete', text: 'Packer Container', value: 'packerContainerId', rules: [v => !!v || 'Packer Container is required'], isRequired: true, form: () => import('./PackerContainerForm'), apiMethod: 'PackerContainers', claim: 'PackerContainers' },
                    { type: 'file', text: 'File', value: 'fileId', rules: [v => !!v || 'File is required'], isRequired: true, form: () => import('./FileForm'), apiMethod: 'Files' },
                    { type: 'enum', text: 'File Type', value: 'fileType', rules: [v => (v !== null && v !== '') || 'File Type is required'], isRequired: true, items: enumService.enumAsSelectList(fileTypeEnum) },
                ],
                apiMethod: 'PackerContainerFiles',
                formTitle: 'Packer Container File',
            }
        },
    };
</script>
